export default __webpack_public_path__ + "1d9a5cb6cfdd24339450e4610cfdb631.svg";